import * as yup from 'yup';

export const initialValues = { motive: '' };

export const schema = yup.object().shape({
  motive: yup.string().required('Required'),
});
